// extracted by mini-css-extract-plugin
module.exports = {"Container":"SectionThree_Container__Q2pe3","Image":"SectionThree_Image__1c69o","Text":"SectionThree_Text__2zUaQ"};